import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { useEffect, useState } from "react";

export function AppShell() {

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      
      let scale = width / 1400;
      
      if (scale > 1) scale = 1;
      
      document.body.style.zoom = `${scale}`;
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.style.zoom = "1";
    };
  }, []);

  return (
    <div className="relative z-10 min-h-screen flex min-w-[1400px]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 px-4 pb-8 pt-4">
          <div className="mx-auto max-w-[1400px] w-full animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
